/* eslint-disable */
import React, { useState } from 'react';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  FormControl,
  Container,
  Divider,
  Grid,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import { useEffectAsync } from '../reactHelper';
import updates from '../common/util/updatesHistory';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  details: {
    flexDirection: 'column',
  },
  paper: {
    padding: '6px 16px',
    textAlign: 'left'
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

const UpdatesPage = () => {
  const classes = useStyles();
  const t = useTranslation();
  const navigate = useNavigate();

  const server = useSelector((state) => state.session.server);

  const [version, setVersion] = useState('0.1');
  const [checkVersion, setCheckVersion] = useState('0.1');
  const [newUpdate, setNewUpdate] = useState('Sistema Atualizado.');

  useEffectAsync(async () => {
    setVersion(server.version);

    const response = await fetch(`${window.location.protocol}//centralderastreamento.net.br/downloads/central_2022_version.txt`, {});
    if (response.ok) {
      const ck = await response.text();
      setCheckVersion(ck.trim());
      if (!version.trim() !== ck.trim()) {
        setNewUpdate('Nova versão disponível!');
      }
    }
  }, [server]);

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedUpdates']}>
      <Container maxWidth="ls" className={classes.container}>
        {server && (
          <>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1">
                  {version}
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} />
                  <Grid item xs={12} sm={4} alignContent="center">
                    <Typography variant="h1" align="center" color="primary">
                      {updates[updates.length - 1].id}
                    </Typography>
                    <Typography variant="subtitle2" align="center" color={version.includes(checkVersion) ? "primary" : "error"}>
                      {newUpdate}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} />

                  <Grid item xs={12} sm={2} />
                  <Grid item xs={12} sm={8}><Divider /></Grid>
                  <Grid item xs={12} sm={2} />

                  <Grid item xs={12} sm={4}>
                    <Typography variant="h5" color="primary">
                      {t('sharedDescription')}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} />
                  <Grid item xs={12} sm={4} />

                  <Grid item xs={12} sm={12}>
                    <Timeline position="alternate">
                      {updates.map(update => {
                        return (
                          <TimelineItem>
                            <TimelineOppositeContent>
                              <Typography variant="body2" color="textSecondary">
                                {update.id}
                              </Typography>
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                              <TimelineDot />
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                              <Paper elevation={3} className={classes.paper}>
                                <ul>
                                  {update.items.map(item => {
                                    return (
                                      <li><Typography >{item.update}</Typography></li>
                                    )
                                  })}
                                </ul>
                              </Paper>
                            </TimelineContent>
                          </TimelineItem>
                        )
                      })}

                    </Timeline>
                  </Grid>

                </Grid>
              </AccordionDetails>
            </Accordion>
          </>
        )}
        <FormControl fullWidth margin="normal">
          <div className={classes.buttons}>
            <Button type="button" color="primary" variant="outlined" onClick={() => navigate.goBack()}>
              {t('sharedGoBack')}
            </Button>
          </div>
        </FormControl>
      </Container>
    </PageLayout>
  );
};

export default UpdatesPage;
